import { useGoogleSignButton } from 'hooks/auth/sign';

import { Spinner } from 'components/shared/Spinner';

import { GoogleIcon } from './GoogleIcon';
import { useAuthGateStore } from 'stores/authGateStore';
import { useShallow } from 'zustand/react/shallow';

export const GoogleSignInButton = () => {
  const { onGoogleButtonPressHandler } = useGoogleSignButton();

  const { status: authStatus, method: authMethod } = useAuthGateStore(
    useShallow(state => ({ status: state.status, method: state.method })),
  );
  const isBusy = authStatus === 'checking' || authStatus === 'redirecting';
  const isLoading = authMethod === 'google' && isBusy;

  return (
    <div className="w-full rounded-[10px] bg-white shadow hover:shadow-md active:shadow-inner">
      <button
        className="relative flex w-full flex-row items-center justify-center disabled:opacity-50"
        disabled={isBusy}
        onClick={onGoogleButtonPressHandler}
      >
        <GoogleIcon />

        <span className="ml-4 py-4 align-middle text-[#858585]">
          Continue with Google
        </span>

        {isLoading && (
          <span className="ml-3">
            <Spinner className="text-black" size={24} />
          </span>
        )}
      </button>
    </div>
  );
};
